export class FullStoryManager {
    constructor() {
        this.storeGetters = null;
        this.client = FullStoryManager.getClient();
    }

    initialize(getters) {
        this.storeGetters = getters;
        if (!this.storeGetters['user/isGuest']) {
            const {
                user, userHash, supportUser,
            } = this.storeGetters['user/decodedToken'];
            const membership = this.storeGetters['user/membership'];
            const isImpersonating = this.storeGetters['user/isImpersonating'];
            this.identify(userHash, {
                displayName: isImpersonating && supportUser && supportUser.name ? `${supportUser.name} as ${user.name}` : user.name,
                email: user.email,
                companyName_str: membership && membership.organization.name,
            });
        }
    }

    /**
     * Detects the FullStory client in the browser and returns it.
     * Returns placeholder object if missing.
     * @returns {object}
     */
    static getClient() {
        if (window.FS) {
            return window.FS;
        }
        return {
            identify: () => null,
        };
    }

    /**
     * Identify user accordig to params
     * @see https://help.fullstory.com/develop-js/identify
     */
    identify(hash, user) {
        this.client.identify(hash, user);
    }

    /**
     * Manual stop session recording
     * @see https://help.fullstory.com/develop-js/identify
     */
    logout() {
        this.client.identify(false);
    }
}

export default new FullStoryManager();
